export const MainPage = () => {
    return (
        <div className="pagecontent">
            <h1>Планировщик рецептов</h1>
            <p>Планировщик рецептов создан, чтобы вдохновлять на приготовление новых блюд, а также для планирования для составления меню на неделю.</p>
            <p>Он позволяет рассчитать необходимые для блюд продукты и составить из них список покупок.</p>
        </div>
    )
}